import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./layouts/Navbar/Navbar";
import LeftSidebar from "./layouts/Sidebar/LeftSidebar";
import { Box, Grid } from "@mui/material";
import UserList from "./pages/UserList/UserList";
import Login from "./pages/LoginIn/Login";
import CourseList from "./pages/CourseList/CourseList";
import ChapterList from "./pages/ChapterList/ChapterList";
import VideoList from "./pages/VideoList/VideoList";
import LeftSidebar1 from "./layouts/Sidebar/LeftSidebar1";
import { ToastContainer } from "react-toastify";
import Navbar2 from "./layouts/Navbar/Navbar2";
import Sidebar from "./layouts/Navbar/Sidebar";
import Sidebar1 from "./layouts/Navbar/Sidebar1";
import CourseDetail from "./pages/CourseDetail/CourseDetail";
import ChapterDetail from "./pages/ChapterDetail/ChapterDetail";
import VideoDetail from "./pages/VideoDetail/VideoDetail";

const App = () => {
  return (
    <>
      <ToastContainer />
      {/* <Router>
        <Navbar />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={0}>
            <Grid item xs={2.5}>
              <LeftSidebar1 />
              <Box
                sx={{ marginTop: 5, borderBottom: "2px solid #E8EFF4" }}
              ></Box>
              <LeftSidebar />
            </Grid>
            <Grid item xs={9.5}>
              <Routes>
                <Route path="/" element={<UserList />} />
                <Route path="/course" element={<CourseList />} />
                <Route path="/chapter" element={<ChapterList />} />
                <Route path="/video" element={<VideoList />} />
              </Routes>
            </Grid>
          </Grid>
        </Box>
      </Router> */}
      <ToastContainer />
      <Router>
        <Navbar2 />
        {/* <Sidebar1/> */}
        <Sidebar />
        <Routes>
          <Route path="/" element={<UserList />} />
          <Route path="/course" element={<CourseList />} />
          <Route path="/chapter" element={<ChapterList />} />
          <Route path="/video" element={<VideoList />} />
          <Route path="/course/course-detail:id" element={<CourseDetail />} />
          <Route path="/chapter/chapter-detail:id" element={<ChapterDetail />} />
          <Route path="/video/video-detail:id" element={<VideoDetail />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
